module.exports = __webpack_public_path__ + "img/img-crm-pc.827afe47.png";